export const EXT_NCBI_GENE_LINK = 'https://www.ncbi.nlm.nih.gov/gene/';
export const EXT_UNIPROT_LINK = 'https://www.uniprot.org/uniprot/';
export const EXT_ENSEMBL_LINK = 'https://www.ensembl.org/Homo_sapiens/Gene/Summary?g=';

export const onHeaderClick = (e) => {
  e.preventDefault();
  e.stopPropagation();
};